<template>
    <div :class="className">
        <div class="head-priamry mb-n20 mb-lg-n26 position-relative rounded w-180px w-lg-340px mx-auto" style="background-color: #6f97f3;">
            <h5 class="tit-txt font-weight-bold">
                {{tit}}
            </h5>
        </div>
        <div class="rounded border pa-20 px-md-30 pa-lg-40 pt-30 pt-md-40 pt-lg-66">
            <slot/>
        </div>
    </div>
</template>

<script>

export default{
    props : {
        className : {type :String, default : ""},
        tit : {type :String, default : ""},
    },
	components: {

	},
    data: () => {
        return {
        }
    },
	created() {
	},
	mounted() {
		this.init();
	},
	methods : {
		init : function() {
		}
	},
}
</script>

<style scoped>
</style>